import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { PIXEL_ART_ICON_SVG } from "./icons";

const ROW_SELECTOR = ".Island.App-toolbar > .Stack_horizontal";

/**
 * 코어 도구 줄 맨 앞에 "픽셀 아트" 버튼을 끼워 넣는다. 코어는 도구 줄에 자식을
 * 받지 않으므로, 줄 안에 host를 두고 포털로 그린다. 코어가 줄을 다시 그리면
 * host가 떨어질 수 있어 MutationObserver로 다시 붙인다.
 */
export const PixelArtToolbarButton = ({
  wrapper,
  active,
  onClick,
}: {
  /** `.canvaschool-editor-canvas`. 이 안에서만 도구 줄을 찾는다. */
  wrapper: HTMLElement | null;
  active: boolean;
  onClick: () => void;
}) => {
  const [host] = useState(() => {
    const element = document.createElement("div");
    element.className = "canvaschool-pixel-host";
    return element;
  });

  useEffect(() => {
    if (!wrapper) {
      return;
    }
    const attach = () => {
      const row = wrapper.querySelector(ROW_SELECTOR);
      if (row && row.firstElementChild !== host) {
        row.prepend(host);
      }
    };
    attach();
    const observer = new MutationObserver(attach);
    observer.observe(wrapper, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      host.remove();
    };
  }, [wrapper, host]);

  return createPortal(
    <>
      <button
        type="button"
        className={`ToolIcon ToolIcon_type_button ToolIcon_size_medium ToolIcon_type_button--show${
          active ? " ToolIcon--selected" : ""
        }`}
        title="픽셀 아트"
        aria-label="픽셀 아트"
        aria-pressed={active}
        data-testid="toolbar-pixel-art"
        onClick={onClick}
      >
        <div
          className="ToolIcon__icon"
          aria-hidden="true"
          dangerouslySetInnerHTML={{ __html: PIXEL_ART_ICON_SVG }}
        />
      </button>
      <div className="App-toolbar__divider" />
    </>,
    host,
  );
};
